import { css } from '@emotion/react'
import { format } from 'date-fns'
import { useEffect, useState } from 'react'

import { colors, typo } from '~/@common/styles'
import _Switch from '~/@common/ui/_Switch/_Switch'
import Button from '~/@common/ui/(Button)/Button/Button'
import { Drawer } from '~/@common/ui/(Drawer)/BaseDrawer'
import Calendar, { type CalendarDateRange } from '~/@common/ui/Calendar/Calendar'

type Props = {
  isOpened: boolean
  dateRange: CalendarDateRange
  onlyHomework: boolean
  dateRangeLabel: string
  onChangeOpen: (isOpened: boolean) => void
  onApply: (next: { dateRange: CalendarDateRange; onlyHomework: boolean }) => void
}

export const CasListMobileOptionDrawer = ({
  isOpened,
  dateRange,
  onlyHomework,
  dateRangeLabel,
  onChangeOpen,
  onApply,
}: Props) => {
  const [localRange, setLocalRange] = useState<CalendarDateRange>(dateRange)
  const [localOnlyHomework, setLocalOnlyHomework] = useState(onlyHomework)

  useEffect(() => {
    if (isOpened) {
      setLocalRange(dateRange)
      setLocalOnlyHomework(onlyHomework)
    }
  }, [isOpened, dateRange, onlyHomework])

  const isApplyDisabled =
    localOnlyHomework === onlyHomework &&
    localRange.start?.date === dateRange.start?.date &&
    localRange.end?.date === dateRange.end?.date

  const close = () => {
    onChangeOpen(false)
    setLocalRange(dateRange)
    setLocalOnlyHomework(onlyHomework)
  }

  return (
    <Drawer
      isOpened={isOpened}
      openDrawer={() => onChangeOpen(true)}
      closeDrawer={close}
      size="full"
      placement="right"
    >
      <Drawer.Content>
        <Drawer.Header>필터 설정</Drawer.Header>
        <Drawer.Body>
          <div css={S.row}>
            <label htmlFor="cat-filter__only-homework" className="label">
              숙제만 보기
            </label>
            <_Switch
              id="cat-filter__only-homework"
              checked={localOnlyHomework}
              onChange={(e) => setLocalOnlyHomework(e.target.checked)}
            />
          </div>
          <Drawer.Divider />
          <div css={S.row}>
            <label className="label">기간</label>
            <label>
              {localRange.start?.dateObj && localRange.end?.dateObj
                ? `${format(localRange.start.dateObj, 'yyyy.MM.dd')}~${format(localRange.end.dateObj, 'yyyy.MM.dd')}`
                : dateRangeLabel}
            </label>
          </div>
          <Drawer.Divider />
          <div css={S.calendarWrap}>
            <Calendar
              style={{
                margin: '20px auto',
                padding: 0,
                width: '360px',
                height: '285px',
              }}
              type="range"
              selectedRange={localRange}
              onRangeSelect={setLocalRange}
            />
          </div>
        </Drawer.Body>
        <Drawer.Divider />
        <Drawer.Footer>
          <div css={S.footer}>
            <Button
              disabled={isApplyDisabled}
              theme="primary"
              minWidth="100%"
              onClick={() => {
                onApply({ dateRange: localRange, onlyHomework: localOnlyHomework })
                onChangeOpen(false)
              }}
            >
              적용하기
            </Button>
          </div>
        </Drawer.Footer>
      </Drawer.Content>
    </Drawer>
  )
}

const S = {
  row: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    .label {
      color: var(--Colors-Gray-800);
      ${typo.body02};
      font-weight: 700;
    }
  `,
  calendarWrap: css`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  footer: css`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 14px 16px 40px;
  `,
}
